"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

/**
 * Listing type tab switcher for city pages.
 * Parent can switch between Camps, Classes, Dining, etc.
 * Task 6.5.2.
 */

type ListingTypeTab = {
  slug: string;
  name: string;
  href: string;
};

export function ListingTypeTabs({
  tabs,
  locationSlug,
}: {
  tabs: ListingTypeTab[];
  locationSlug: string;
}) {
  const pathname = usePathname();

  if (tabs.length <= 1) return null;

  return (
    <nav className="mb-6 flex gap-1 overflow-x-auto border-b border-slate-200">
      {tabs.map((tab) => {
        const isActive =
          pathname === tab.href ||
          (tab.slug === "camps" && pathname === `/${locationSlug}/camps`);

        return (
          <Link
            key={tab.slug}
            href={tab.href}
            className={`whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
              isActive
                ? "border-wildroost-teal text-wildroost-teal"
                : "border-transparent text-wildroost-ink/50 hover:border-slate-300 hover:text-wildroost-ink/70"
            }`}
          >
            {tab.name}
          </Link>
        );
      })}
    </nav>
  );
}
